// extracted by mini-css-extract-plugin
export default {"btnExp":"FeaturedProjects_btnExp__L7lPw"};